module.exports = __webpack_public_path__ + "img/fruit_text1.dc67837f.png";